import React from 'react';
import { Tag as AntdTag, Icon } from 'antd';
import styled from 'styled-components';


const CheckableTag = styled(AntdTag.CheckableTag)`
&& {
    color: ${props => props.checked ? '#3B7CFF' : '#666666'};
    border-color: ${props => props.checked ? '#3B7CFF' : '#D4D4D4'};
    border-style: solid;
    border-radius: 11px;
    padding: 1px 7px;
    margin-bottom: 2px;
    background: #FFF;
    &&:hover{
      color: ${props => props.checked ? '#3B7CFF' : '#666666'};
    }

}
`;

// const Icon = styled(AntdIcon)`
//     font-size: 10px;
// `;

const Tag = ({checked, handleChange, children, value})  =>
      (
        <CheckableTag
          checked={checked}
          onChange={(checked) => handleChange(checked, value)}
        >
          {children}
          <span>
            {checked && (
              <Icon type="close" style={{ color: "#3B7CFF" }} />
            )}
          </span>
        </CheckableTag>
    );
export default Tag;


// WEBPACK FOOTER //
// ./src/components/Tag/Tag.js